module.exports = __webpack_public_path__ + "assets/img/26_1584_big.14a0e7dc.jpg";